import { FaMapMarkerAlt, FaStore } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function SellerCard({ biz }) {
  const navigate = useNavigate();

  return (
    <div className="group bg-white rounded-[2rem] border border-gray-100 hover:border-orange-500 transition-all duration-300 flex flex-col overflow-hidden shadow-sm hover:shadow-xl">

      {/* Image */}
      <div className="relative h-32 sm:h-48 overflow-hidden">
        <img
          src={biz?.profileImage || "/placeholder.jpg"}
          alt={biz?.Name}
          className="w-full h-full object-cover group-hover:scale-110 transition duration-500"
        />

        <div className="absolute top-2 right-2 bg-white/90 backdrop-blur px-2 py-1 rounded-lg text-[10px] font-bold flex items-center gap-1 shadow-sm">
          <FaMapMarkerAlt className="text-orange-500" />
          {biz?.lga || "Lagos"}
        </div>
      </div>

      {/* Body */}
      <div className="p-3 sm:p-5 flex flex-col flex-1">

        <h2 className="font-black text-gray-900 text-sm sm:text-lg truncate group-hover:text-orange-500 transition">
          {biz?.Name}
        </h2>

        <p className="text-gray-500 text-[11px] sm:text-sm mt-1 leading-snug line-clamp-2 min-h-[32px] sm:min-h-[40px]">
          {biz?.bio || "Verified Seller in Lagos"}
        </p>

        {/* Tags */}
        {biz?.fields?.length > 0 && (
          <div className="mt-3 flex flex-wrap gap-1">

            {biz.fields.slice(0, 2).map((field, index) => (
              <span
                key={index}
                className="px-2 py-0.5 bg-orange-50 text-orange-600 rounded-md text-[9px] sm:text-[10px] font-black uppercase tracking-tighter"
              >
                {field}
              </span>
            ))}

            {biz.fields.length > 2 && (
              <span className="text-[10px] text-gray-400">
                +{biz.fields.length - 2}
              </span>
            )}

          </div>
        )}

        <div className="mt-4 pt-4 border-t border-gray-100">

          <button
            onClick={() => navigate(`/shop/${biz._id}`)}
            className="w-full flex items-center justify-center gap-2 bg-gray-900 hover:bg-orange-500 text-white py-2.5 sm:py-3 rounded-2xl transition text-[11px] sm:text-sm font-bold"
          >
            <FaStore />
            View Store
          </button>

        </div>

      </div>

    </div>
  );
}